import { connect } from 'react-redux';

import {
  getCategoriesFilter,
  getFurnitureFilter,
  getBillsFilter,
  getRoomsFilter,
  getCountryCode,
  getRegistrationFilter,
  getRecentlyAddedFilter,
  getSearchParams,
  getRulesFilter,
  getGenderFilter,
  getSuitableForFilter,
} from '../../selectors';
import OtherFilterDesktop from 'ha/components/Filters/OtherFilterDesktop';

import {
  onChangeFilters,
  toggleFilterPopover,
  loadPreviewNumberOfListings,
  clearPreviewNumberOfListings,
} from '../../actions';

export default connect(
  state => ({
    typeFilter: getCategoriesFilter(state),
    furnitureFilter: getFurnitureFilter(state),
    billsFilter: getBillsFilter(state),
    roomsFilter: getRoomsFilter(state),
    registrationFilter: getRegistrationFilter(state),
    suitableForFilter: getSuitableForFilter(state),
    recentlyAddedFilter: getRecentlyAddedFilter(state),
    rulesFilter: getRulesFilter(state),
    genderFilter: getGenderFilter(state),
    countryCode: getCountryCode(state),
    searchParams: getSearchParams(state),
  }),
  {
    onChangeFilters,
    toggleFilterPopover,
    loadPreviewNumberOfListings,
    clearPreviewNumberOfListings,
  },
)(OtherFilterDesktop);
